module.exports = __webpack_public_path__ + "img/b419b740c8818ab4d7a74b4afc2cfca2.b630557f.png";